import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  CustomScriptsQuery,
  Error,
  GetCustomScriptList
} from '@eggplant/types'
import type { ReactElement } from 'react'

export interface Props {
  params?: CustomScriptsQuery
  children?: (data: GetCustomScriptList) => ReactElement | null
  onSuccess?: (data: GetCustomScriptList) => void
  onError?: (error: Error) => void
  shortErrorMessage?: string
}

const GetCustomScriptListRequest = ({
  params,
  onError,
  onSuccess,
  children,
  shortErrorMessage
}: Props) => {
  const url = `${TEST_CONFIG_SERVICE}/custom_scripts`

  const { requestParams } = useGetParamsWithSpaceId<CustomScriptsQuery|undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetCustomScriptListRequest
